function makeDeepCopy(value) {
  return JSON.parse(JSON.stringify(value));
}

export default makeDeepCopy;
